import {CommandCaller} from "../lib/commands";
import {CallJs} from "../lib/types";
import {addReportsToDiv, EMCallJsParams} from "./reports";

export type EmailManagerCommandProps = {
	ajaxPageUrl:string
}


export namespace admin {
	export const displayReports: CallJs<EMCallJsParams> = (apply, props) => {
		const div = document.createElement("div")
		apply(div)
		addReportsToDiv(div, props)
	}
	export const getFromEmailAddressStatsGridData = (props:EmailManagerCommandProps) => {
		return (callback:(_:string) => void) => {
			const cc = new CommandCaller(props.ajaxPageUrl);
			(cc.runGet('emailmanager.fromEmailAddressStats',{}) as Promise<{content:string}>).then(
				(response) => { callback(response.content) }
			)
		}
	}
}


// WEBPACK FOOTER //
// ./src/emailmanager/emailmanager.ts